export default "__VITE_ASSET__Cyv_XyHU__"